import React from "react";
import {Button, Dropdown} from "react-bootstrap";
import {modalActions} from "../../../../actions/modal.actions";
import {connect} from "react-redux";
import {withNamespaces} from "react-i18next";
import {networkDeviceActions} from "../../../../actions/network-device.actions";
import DeviceRestartButton from "../../../../components/DeviceRestartButton";
import {Link} from "react-router-dom";
import {claimTypes} from "../../../../constants/claim.constants";
import NetworkDeviceActionPowerButton from "./NetworkDeviceActionPowerButton";
import {useHistory} from "react-router";
import {history} from "../../../../helpers/history";
import NetworkDeviceActionPowerOnOffButtons from "./NetworkDeviceActionPowerOnOffButtons";

const NetworkDeviceActionButtons = ({row, t, user, showModal, hideModal, shutDownPc, removeDevice, size = "", isMobile = false}) => {
    // claim key
    const claims = {
        crudBtn:        user[`c_network-device.actions.crud`] || null,
        contentBtn:     user[`c_network-device.actions.btn-content`] || null,
        powerOffBtn:    user[`c_network-device.actions.btn-power-off`] || null,
        resetBtn:       user[`c_network-device.actions.btn-restart`] || null,
        daliConfigBtn:  user[`c_network-device.actions.btn-dali-config`] || null
    };

    const { deviceType } = row;

    const openModalPowerOff = (model) => {
        showModal({
            open: true,
            title: t('are-you-sure'),
            message: t('shutdown-pc-msg') + ' ' + model.label,
            confirmLabel: t('shutdown-btn'),
            confirmIcon: 'fa-power-off',
            classNameBtnConfirm: 'btn-danger',
            dataId: model.id,
            confirmAction: (id) => {
                shutDownPc(id);
                hideModal();
            },
            closeModal: closeModal,
        }, 'confirm')
    };


    const openModalRemoveDevice = (model) => {
        showModal({
            open: true,
            title: t('are-you-sure'),
            message: t('delete-msg') + `<h5> ${model.label} </h5>`,
            confirmLabel: t('delete-btn'),
            confirmIcon: 'fa-trash',
            classNameBtnConfirm: 'btn-danger',
            dataId: model.id,
            confirmAction: (id) => {
                removeDevice(id);
                hideModal();
            },
            closeModal: closeModal,
        }, 'confirm')
    };

    const onClickLabel = (networkDeviceModel, event) => {
        event.preventDefault();
        showModal({
            open: true,
            large: true,
            title: 'Device info',
            networkDeviceModel: networkDeviceModel,
            closeModal: closeModal
        }, 'deviceInfo')
    };

    const closeModal = () => {
        hideModal()
    };

    const goTo = (routing) => {
       history.push(routing);
    }


    return (
        <React.Fragment>
            {/*large resolution*/}
             <Dropdown className="d-lg-block d-xl-none">
                <Dropdown.Toggle id="dropdown-basic">
                    { t('actions') }
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    { isMobile ? (
                        <Dropdown.Item onClick={(event) => onClickLabel(row, event)}>
                            <i className="fas fa-info-circle"/> &nbsp; { t('details') }
                        </Dropdown.Item>
                    ) : (<React.Fragment/>) }

                    { (deviceType.label === "PC" || deviceType.label === "PC Linux") && claims.contentBtn === claimTypes.READ_WRITE ? (
                        <Dropdown.Item onClick={() => goTo("/panel/network-device/content/" + row.id)}>
                            <i className="far fa-file-archive"/> &nbsp; { t('content-btn') }
                        </Dropdown.Item>
                    ) : (<React.Fragment/>) }

                    { (deviceType.label === "PC" || deviceType.label === "PC Linux") && row.isOnline ? (
                        <Dropdown.Item onClick={() => goTo("/panel/network-device/monitor/" + row.id)}>
                            <i className="fas fa-chart-bar"/> &nbsp; { t('stats') }
                        </Dropdown.Item>
                    ) : (<React.Fragment/>) }

                    {  (deviceType.label === "PC" || deviceType.label === "PC Linux") &&  claims.powerOffBtn === claimTypes.READ_WRITE ? (
                        <NetworkDeviceActionPowerButton size={size} claimButton={claims.powerOffBtn} row={row} dropdownItem={true} />
                    ) : (<React.Fragment/>)}

                    { (deviceType.label === "PC" || deviceType.label === "PC Linux") && claims.resetBtn === claimTypes.READ_WRITE ? (
                        <DeviceRestartButton size={size} deviceName={row.label} id={row.id} dropdownItem={true} />
                    ) :  (<React.Fragment/>)}

                    { deviceType.label?.toLowerCase().includes('pjlink') && claims.powerOffBtn === claimTypes.READ_WRITE ? (
                        <NetworkDeviceActionPowerButton size={size} claimButton={claims.powerOffBtn} row={row} dropdownItem={true}/>
                    ) : (<React.Fragment/>) }

                    { (deviceType.label === "UDP device" || deviceType.label?.toLowerCase().includes('lantick')) && claims.powerOffBtn === claimTypes.READ_WRITE ? (
                        <NetworkDeviceActionPowerOnOffButtons size={size} claimButton={claims.powerOffBtn} row={row} dropdownItem={true} />
                    ) : (<React.Fragment/>) }

                    { deviceType.label === "Dali Helvar" && claims.daliConfigBtn === claimTypes.READ_WRITE ? (
                        <Dropdown.Item onClick={() => goTo(`/panel/network-device/dali/helvar/${row.id}/area`)}>
                            <i className="fas fa-cog"/>  &nbsp;{t('config-dali-btn')}
                        </Dropdown.Item>
                    ) : (<React.Fragment/>) }

                    { deviceType.label === "PXM Modbus" && claims.daliConfigBtn === claimTypes.READ_WRITE  ? (
                        <Dropdown.Item onClick={() => goTo(`/panel/network-device/dmx/pxm/${row.id}/scenes`)}>
                            <i className="fas fa-cog"/>  &nbsp;{t('config-dali-btn')}
                        </Dropdown.Item>
                    ) : (<React.Fragment/>) }

                    { deviceType.label === "Dali Es-System" && claims.daliConfigBtn === claimTypes.READ_WRITE  ? (
                        <Dropdown.Item onClick={() => goTo(`/panel/network-device/dali/es-system/${row.id}/area`)}>
                            <i className="fas fa-cog"/>  &nbsp;{t('config-dali-btn')}
                        </Dropdown.Item>
                    ) : (<React.Fragment/>) }

                    { claims.crudBtn === claimTypes.READ_WRITE ? (
                        <Dropdown.Item onClick={() => goTo("/panel/network-device/edit/" + row.id)}>
                            <i className="fas fa-edit"> </i> &nbsp; { t('edit') }
                        </Dropdown.Item>
                    ) : (<React.Fragment/>) }

                    { claims.crudBtn === claimTypes.READ_WRITE ? (
                        <Dropdown.Item onClick={() => openModalRemoveDevice(row)}>
                            <i className="fas fa-trash"> </i> &nbsp; { t('delete') }
                        </Dropdown.Item>
                    ) : (<React.Fragment/>) }

                </Dropdown.Menu>
            </Dropdown>


            {/*ultra large resolution*/}
            <div className="d-none d-xl-block">
                { (deviceType.label === "PC" || deviceType.label === "PC Linux") && claims.contentBtn === claimTypes.READ_WRITE ? (
                    <Link to={"/panel/network-device/content/" + row.id}>
                        <Button active={row.diagnosticMode} size={size} className="mx-1" variant={"outline-secondary"} >
                            { t('content-btn') } &nbsp; <i className="far fa-file-archive"> </i>
                        </Button>
                    </Link>
                ) : (<React.Fragment/>) }

                {/*{ deviceType.label === "PC"  ? (*/}
                {/*    <Link to={`/panel/network-device/logs/${row.id}`}>*/}
                {/*        <Button size={size} className="mx-1" variant={"outline-success"}>*/}
                {/*            { t('logs') } &nbsp; <i className="fas fa-clipboard-list"/>*/}
                {/*        </Button>*/}
                {/*    </Link>*/}
                {/*) : (<React.Fragment/>) }*/}

                { (deviceType.label === "PC" || deviceType.label === "PC Linux") && row.isOnline ? (
                    <Link to={"/panel/network-device/monitor/" + row.id}>
                        <Button size={size} className="mx-1" variant={"outline-success"}>
                            { t('stats') } &nbsp; <i className="fas fa-chart-bar"/>
                        </Button>
                    </Link>
                ) : (<React.Fragment/>) }

                {  (deviceType.label === "PC" || deviceType.label === "PC Linux") &&  claims.powerOffBtn === claimTypes.READ_WRITE ? (
                    <NetworkDeviceActionPowerButton size={size} claimButton={claims.powerOffBtn} row={row} />
                ) : (<React.Fragment/>) }

                { (deviceType.label === "PC" || deviceType.label === "PC Linux") && claims.resetBtn === claimTypes.READ_WRITE ? (
                    <DeviceRestartButton size={size} deviceName={row.label} id={row.id} />
                ) :  (<React.Fragment/>)}

                { deviceType.label?.toLowerCase().includes('pjlink') && claims.powerOffBtn === claimTypes.READ_WRITE ? (
                    <NetworkDeviceActionPowerButton size={size} claimButton={claims.powerOffBtn} row={row} />
                ) : (<React.Fragment/>) }

                { (deviceType.label === "UDP device" || deviceType.label?.toLowerCase().includes('lantick')) && claims.powerOffBtn === claimTypes.READ_WRITE ? (
                    <NetworkDeviceActionPowerOnOffButtons size={size} claimButton={claims.powerOffBtn} row={row}  />
                ) : (<React.Fragment/>) }


                { deviceType.label === "Dali Helvar" && claims.daliConfigBtn === claimTypes.READ_WRITE ? (
                    <Link to={`/panel/network-device/dali/helvar/${row.id}/area`}>
                        <Button variant={"info"} size={size} className="mx-1">
                            {t('config-dali-btn')} &nbsp; <i className="fas fa-cog"> </i>
                        </Button>
                    </Link>
                ) : (<React.Fragment/>) }

                { deviceType.label === "PXM Modbus" && claims.daliConfigBtn === claimTypes.READ_WRITE  ? (
                    <Link to={`/panel/network-device/dmx/pxm/${row.id}/scenes`}>
                        <Button variant={"info"} size={size} className="mx-1">
                            {t('config-dali-btn')} &nbsp; <i className="fas fa-cog"> </i>
                        </Button>
                    </Link>
                ) : (<React.Fragment/>) }

                { deviceType.label === "Dali Es-System" && claims.daliConfigBtn === claimTypes.READ_WRITE  ? (
                    <Link to={`/panel/network-device/dali/es-system/${row.id}/area`}>
                        <Button variant={"info"} size={size} className="mx-1">
                            {t('config-dali-btn')} &nbsp; <i className="fas fa-cog"> </i>
                        </Button>
                    </Link>
                ) : (<React.Fragment/>) }

                { claims.crudBtn === claimTypes.READ_WRITE ? (
                    <Link to={"/panel/network-device/edit/" + row.id}>
                        <Button variant={"primary"} size={size} className="mx-1">
                            <i className="fas fa-edit"> </i>
                        </Button>
                    </Link>
                ) : (<React.Fragment/>) }

                { claims.crudBtn === claimTypes.READ_WRITE ? (
                    <Button variant={"danger"} size={size} className="mx-1" onClick={() => openModalRemoveDevice(row)}>
                        <i className="fas fa-trash"> </i>
                    </Button>
                ) : (<React.Fragment/>) }
            </div>
        </React.Fragment>
    )
};

const mapStateToProps = state => {
    const { user } = state.authenticationReducer;
    return {
        user
    }
};

const mapDispatchToProps = dispatch => ({
    hideModal: () => dispatch(modalActions.hideModal()),
    shutDownPc: (id) => dispatch(networkDeviceActions.shutDownPc(id)),
    powerOnPc: (id) => dispatch(networkDeviceActions.powerOnPc(id)),
    removeDevice: (id) => dispatch(networkDeviceActions.removeDeviceById(id)),
    showModal: (modalProps, modalType) => {
        dispatch(modalActions.showModal({ modalProps, modalType }))
    }
});

export default withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(NetworkDeviceActionButtons));
